// src/components/home/userComponents/PlanBreakdownPie.jsx

import React from "react";
import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from "recharts";

const COLORS = ["#3b82f6", "#8b5cf6", "#ec4899", "#f59e0b", "#10b981", "#06b6d4"];

export default function PlanBreakdownPie({ planCounts }) {
  const hasNoData = !planCounts || planCounts.length === 0;
  const hasSinglePlan = planCounts && planCounts.length === 1;

  if (hasNoData) {
    return (
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-5">
        <h4 className="text-sm font-semibold mb-4 text-gray-900 dark:text-white">
          Subscribers by Plan
        </h4>
        <div className="flex items-center justify-center h-[180px]">
          <div className="text-center">
            <p className="text-sm text-gray-500 dark:text-gray-400">No subscription data yet</p>
            <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">Data will appear as users subscribe</p>
          </div>
        </div>
      </div>
    );
  }

  if (hasSinglePlan) {
    const plan = planCounts[0];
    return (
      <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-5">
        <h4 className="text-sm font-semibold mb-4 text-gray-900 dark:text-white">
          Subscribers by Plan
        </h4>
        <div className="flex items-center justify-center h-[180px]">
          <div className="text-center">
            <div className="inline-flex items-center justify-center w-24 h-24 rounded-full bg-gradient-to-br from-blue-100 to-blue-50 dark:from-blue-500/20 dark:to-blue-500/10 mb-3">
              <div className="text-center">
                <div className="text-2xl font-bold text-blue-600 dark:text-blue-400">100%</div>
                <div className="text-xs text-blue-600/70 dark:text-blue-400/70">{plan.name}</div>
              </div>
            </div>
            <p className="text-xs text-gray-400 dark:text-gray-500">No comparison data yet</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-xl p-5">
      <h4 className="text-sm font-semibold mb-4 text-gray-900 dark:text-white">
        Subscribers by Plan
      </h4>
      <ResponsiveContainer width="100%" height={180}>
        <PieChart>
          <Pie
            data={planCounts}
            dataKey="value"
            nameKey="name"
            outerRadius={70}
            label={false}
            strokeWidth={0}
          >
            {planCounts.map((entry, idx) => (
              <Cell key={`slice-${idx}`} fill={COLORS[idx % COLORS.length]} />
            ))}
          </Pie>
          <Tooltip 
            contentStyle={{
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              border: '1px solid #e5e7eb',
              borderRadius: '8px',
              fontSize: '11px',
              padding: '6px 10px'
            }}
          />
          <Legend 
            verticalAlign="bottom" 
            height={28}
            iconType="circle"
            wrapperStyle={{ fontSize: '11px' }}
          />
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
}
